import { Avatar, Box, Chip, FormControl, FormLabel, Grid, MenuItem, Radio, RadioGroup, Select, Stack, Typography, Button, Paper } from "@mui/material";
import FormControlLabel from '@mui/material/FormControlLabel';
import { Field, FieldArray, Form, Formik, getIn } from "formik";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from "react-router-dom";
import Editor from 'react-simple-wysiwyg';
import AutoSuggestion from "../../components/autocomplete";
import NormalInput from "../../components/inputs/normalInput";
import NumberInput from "../../components/inputs/normalInput/number";
import Schema from "../../schema";
import { COMPANY_QUE_FLOW, setCompanyName } from "../../utils/common";
import { CAMPAIGN_BANNER_IMAGE_ALLOWED_TYPES, FONT_PREFERENCES, FORM_INPUTFIELD_STYLES, FORM_SELECTFIELD_STYLES, INFLUENCER_NICHE, PLATFORMS_IMGS_LIST, TWO_FACTOR_AUTH_VALUE, citiesInIndia } from "../../utils/constant";
import { createCompany } from "./action";
import FormHeading from '../../utils/FormHeading';
import DeleteIcon from "../../assets/images/icons/X.svg";
import imageIconWhite from '../../assets/images/icons/ImageIconWhite.svg'
import check from '../../assets/images/icons/greenCheck.svg'
import imageIcon from '../../assets/images/icons/imageIcon.svg'
import deleteIconRed from '../../assets/images/icons/deleteIconRed.svg'
import removeIcon from '../../assets/images/icons/removeIcon.svg'
import addIcon from '../../assets/images/icons/addIcon.svg'
function CustomPaperComponent(props) {
  return (
    <Paper
      {...props}
      elevation={3}
      sx={{
        borderRadius: '10px',
        marginTop: 1,
        scrollbarWidth: 'none',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
       overflowY: 'auto',
    overflowX: 'hidden',
    maxHeight:'300px',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
      }}
    />
  );
}
const AddEditCompany = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { state } = useLocation();
    const { paramMasterList,isScreenZoomed } = useSelector((state) => state.commonSlice);
    const [data, setData] = useState([]);
    const [bannerImageError, setBannerImageError] = useState("")
    const [preview, setPreview] = useState("");

    const [fontReference, setFontReference] = useState([]);
    useEffect(() => {

        if (paramMasterList?.length > 0) {
            let para = paramMasterList;
            setData(JSON.parse(para?.find((v) => v.parameterkey === INFLUENCER_NICHE)?.value));
            setFontReference(JSON.parse(para?.find((v) => v.parameterkey === FONT_PREFERENCES)?.value));
        }

    }, [paramMasterList])


    let brandMsg = state?.brandValueAndMessaging || {};
    const initialValues = {
        companyName: state?.companyName || '',
        contactPersonName: state?.contactPersonName || '',
        phoneNumber: state?.phoneNumber || '',
        email: state?.email || '',
        instagram: state?.socialMedia?.instagram?.length > 0 ? ["instagram"] : [],
        instagramInfo: state?.socialMedia?.instagram || [],
        linkedin: state?.socialMedia?.linkedin?.length > 0 ? ["linkedin"] : [],
        linkedinInfo: state?.socialMedia?.linkedin || [],
        youtube: state?.socialMedia?.youtube?.length > 0 ? ["youtube"] : [],
        youtubeInfo: state?.socialMedia?.youtube || [],
        facebook: state?.socialMedia?.facebook?.length > 0 ? ["facebook"] : [],
        facebookInfo: state?.socialMedia?.facebook || [],
        geoPreferences: state?.targetAudience?.geoPreferences || [],
        niche: state?.brandBasics?.niche?.length > 0 ? data
            ?.filter((v) => state?.brandBasics?.niche.includes(v.option))
            .map((v) => ({
                id: v.id,
                option: v.option,
            }))
            : [],
        idealDescription: state?.targetAudience?.description || '',
        description: state?.brandBasics?.description || '',
        primaryColor: state?.branding?.primaryColor || '',
        secondaryColor: state?.branding?.secondaryColor || '',
        font: state?.branding?.font || '',
        logo: state?.logo || "",
        messagesKey: brandMsg?.messages || '',
        toneOfVoice: brandMsg?.toneOfVoice || '',
        additionalInformation: brandMsg?.additionalInformation || '',
        password: '',
        confirmPassword: '',
        id: state?.userId || undefined,
        comingFrom: state?.comingFrom || "",
        twoFactorAuthType: state?.twoFactorAuthType || "",
        keyMessages: state?.keyMessages || "",
        brandTone: state?.brandTone || "",
        influencersCampaign: state?.influencersCampaign || "",
        lastMonthInfluencers: state?.lastMonthInfluencers || "",
        support: state?.support || ""
    }
    const handleKeyDown = (event) => {
        // Prevent form submission when Enter key is pressed
        if (event.key === 'Enter' && event.target.type !== 'button') {
            event.preventDefault();
        }
    };

    return (
        <>                <Formik
            initialValues={initialValues}
            validationSchema={Schema.Company}
            enableReinitialize
            onSubmit={(values) => {

                if (state?.userId !== undefined) {
                    values.userId = state?.userId;
                }
                if (state?.comingFrom) {
                    setCompanyName(values.companyName);
                }

                dispatch(createCompany(values, navigate));
            }}
        >
            {({
                errors,
                handleBlur,
                handleChange,
                handleSubmit,
                touched,
                values,
            }) => {

                const handleDrop = (e) => {
                    e.preventDefault();
                    const file = e.dataTransfer.files[0];
                    handleFile(file);
                    e.target.value = null;
                };
                const handleFileChange = (e) => {
                    const file = e.target.files[0];
                    handleFile(file);
                    e.target.value = null;
                };

                const handleFile = async (file) => {
                    if (!file) return;
                    if (!CAMPAIGN_BANNER_IMAGE_ALLOWED_TYPES.includes(file.type)) {
                        setBannerImageError('Invalid file format. Please upload a JPEG or PNG image.')
                        return;
                    }
                    const maxSize = 1 * 1024 * 1024;
                    if (file.size > maxSize) {
                        setBannerImageError('File size exceeds 1 MB. Please upload a smaller file.')
                        return;
                    }
                    setBannerImageError("")
                    const img = new Image();
                    const reader = new FileReader();

                    reader.onload = (e) => {
                        img.src = e.target.result;

                        img.onload = async () => {
                            setBannerImageError("");
                            const base64 = e.target.result;
                            setPreview(base64);

                            handleChange({
                                target: {
                                    name: "logo",
                                    value: file,
                                }
                            })
                        };
                    };

                    reader.readAsDataURL(file);
                };
                const handleDeleteBannerImage = (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    handleChange({
                        target: {
                            name: "logo",
                            value: "",
                        }
                    })
                    setPreview(null);
                }
                return (

                    <Form onSubmit={(e) => {
                        e.preventDefault();
                        if (Object.keys(errors).length > 0) {

                            document?.getElementsByName(Object?.keys(errors)[0])[0]?.focus();
                        }
                        handleSubmit();
                    }} onKeyDown={handleKeyDown}>

                        <Box sx={{ marginTop: '10px',paddingLeft:'16px' }}>
                            <Stack direction="row" alignItems={"flex-start"} sx={{ border: '0px solid red', }}>
                                <Box sx={{ width: '40%', }}><Typography sx={{ fontSize: '20px', fontWeight: 400, color: 'black', fontFamily: 'var(--family2) !important' }}>
                                    General Information</Typography></Box>
                                <Box sx={{ width: '60%', paddingX: 5, border: '0px solid red' }}>

                                    <Grid container justifyContent={"space-evenly"} gap={1.5} sx={{
                                        paddingY: '24px', background: '#FFF', border: '0px solid purple', boxShadow: '0px 0px 24px 0px rgba(0, 0, 0, 0.10)', borderRadius: '10px'
                                    }}>
                                        <Grid item lg={5.6}>
                                            <FormLabel><FormHeading heading="Company Name" isRequired={true} /></FormLabel>

                                            <NormalInput
                                                name={"companyName"}
                                                isRequired={true}
                                                type={"text"}
                                                focused={false}
                                                style={FORM_INPUTFIELD_STYLES}
                                                label={("")}
                                                sizeval="medium"
                                                values={values.companyName}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={Boolean(touched.companyName) && errors.companyName}
                                                helperText={touched.companyName && errors.companyName}
                                            />
                                        </Grid>
                                        <Grid item lg={5.6}>
                                            <FormLabel><FormHeading heading="Contact Person Name" isRequired={true} /></FormLabel>
                                            <NormalInput
                                                name={"contactPersonName"}
                                                style={FORM_INPUTFIELD_STYLES}
                                                isRequired={true}
                                                type={"text"}
                                                focused={false}
                                                label={("")}
                                                sizeval="medium"
                                                values={values.contactPersonName}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={Boolean(touched.contactPersonName) && errors.contactPersonName}
                                                helperText={touched.contactPersonName && errors.contactPersonName}
                                            />
                                        </Grid>
                                        <Grid item lg={5.6}>
                                            <FormLabel><FormHeading heading="Email" isRequired={true} /></FormLabel>

                                            <NormalInput
                                                name={"email"}
                                                isRequired={true}
                                                style={FORM_INPUTFIELD_STYLES}
                                                type={"text"}
                                                focused={false}
                                                label={("")}
                                                sizeval="medium"
                                                values={values.email}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={Boolean(touched.email) && errors.email}
                                                helperText={touched.email && errors.email}
                                            />
                                        </Grid>
                                        <Grid item lg={5.6}>
                                            <FormLabel><FormHeading heading="phone Number" isRequired={true} /></FormLabel>
                                            <NumberInput
                                                name={"phoneNumber"}
                                                style={FORM_INPUTFIELD_STYLES}
                                                isRequired={true}
                                                type={"number"}
                                                focused={false}
                                                label={("")}
                                                sizeval="medium"
                                                values={values.phoneNumber}
                                                onChange={(e) => {
                                                    if (e.target.value.length <= 10) {
                                                        handleChange(e);
                                                    } else {
                                                        e.preventDefault();
                                                    }
                                                }}
                                                onBlur={handleBlur}
                                                error={Boolean(touched.phoneNumber) && errors.phoneNumber}
                                                helperText={touched.phoneNumber && errors.phoneNumber}
                                            />
                                        </Grid>
                                        <Grid item lg={5.6}>
                                            <FormLabel><FormHeading heading="2-Factor Authentication" isRequired={true} /></FormLabel>
                                            <Select
                                                sx={FORM_SELECTFIELD_STYLES} MenuProps={{
                                                    PaperProps: {
                                                        sx: {
                                                            borderRadius: "8px",
                                                            mt: 1,
                                                        },
                                                    },
                                                }}
                                                values={values.twoFactorAuthType} handleChange={handleChange}
                                                name={`twoFactorAuthType`}
                                            >
                                                {TWO_FACTOR_AUTH_VALUE?.map(
                                                    (v) => {
                                                        return (
                                                            <MenuItem value={v} key={v}>
                                                                {v}
                                                            </MenuItem>
                                                        );
                                                    }
                                                )}</Select>
                                        </Grid>
                                        <Grid item lg={5.6}>
                                            {/* need empty for layout */}
                                        </Grid>
                                    </Grid>
                                </Box>
                            </Stack>

                            <Stack direction="row" alignItems={"flex-start"} sx={{ border: '0px solid red', marginTop: '32px' }}>
                                <Box sx={{ width: '40%' }}><Typography sx={{ fontSize: '20px', fontWeight: 400, color: 'black', fontFamily: 'var(--family2) !important' }}>
                                    Company Basics</Typography></Box>
                                <Box sx={{ width: '60%', paddingX: 5, border: '0px solid red' }}>

                                    <Grid container justifyContent={"space-evenly"} gap={1.5} sx={{
                                        paddingY: '24px', background: '#FFF', border: '0px solid purple', boxShadow: '0px 0px 24px 0px rgba(0, 0, 0, 0.10)', borderRadius: '10px'
                                    }}>
                                        <Grid item lg={5.6}>
                                            <FormLabel><FormHeading heading="industry/Niche" isRequired={true} /></FormLabel>
                                            <AutoSuggestion
                                                limitTags={1}
                                                CustomPaperComponent={CustomPaperComponent}
                                                sx={FORM_SELECTFIELD_STYLES}
                                                multiple={true}
                                                required={true}
                                                disableClearable={true}
                                                value={values?.niche || []}
                                                className="auto-chips-cover"
                                                label={""}
                                                onChange={(_e, newValue) => {
                                                    handleChange({
                                                        target: { name: "niche", value: newValue },
                                                    });
                                                }}
                                                renderTags={(value, getTagProps) => {
                                                    if (!Array.isArray(value)) return null;
                                                    return value.map((option, index) => {
                                                        return (
                                                            <Chip
                                                                key={option.option || option}
                                                                avatar={<Avatar alt={option.option} src={`/influncersCategoryIcons/category_icon_${option.id}.svg`} sx={{ height: 20, width: 20 }} />}
                                                                label={<Typography sx={{ fontSize: '14px', fontWeight: 500, color: 'white' }}>
                                                                    {option.option?.substring(0, 10) || option}
                                                                </Typography>}
                                                                {...getTagProps({ index })}
                                                                sx={{
                                                                    background: 'black !important',
                                                                    borderRadius: '62px', border: '0px solid #CCCBCB',
                                                                    padding: "3px 8px", height: '32px'
                                                                }}
                                                                deleteIcon={<img src={DeleteIcon} style={{ filter: 'brightness(0) invert(1)', }} alt="delete icon" width={24} height={24} />} // Custom delete icon
                                                            />
                                                        )
                                                    })
                                                }
                                                }
                                                placeholder="Select Industry/Niche"
                                                defaultValue={values?.niche || []}
                                                id={`users-${values?.niche?.length}`}
                                                size="small"
                                                name="niche"
                                                error={Boolean(touched.niche) && errors.niche}
                                                helperText={touched.niche && errors.niche}
                                                options={data}
                                                isOptionEqualToValue={(option, value) => option.id === value.id}
                                                getOptionLabel={(option) => option?.option ?? ""}
                                                renderOption={(props, option) => {
                                                    return (
                                                        <>
                                                            <li {...props} style={{ padding: '2px 8px', width: '100%', margin: "0 3px", borderRadius: '0px', border: '0px solid #CCCBCB', display: 'flex', justifyContent: 'flex-start', alignItems: 'center', flexDirection: 'row', gap: 2 }}> <img src={`/influncersCategoryIcons/category_icon_${option.id}.svg`} alt={`../../assets/images/influncersCategoryIcons/category_icon_${option.id}`} style={{ height: '20px', width: '20px' }} />&nbsp;<Typography sx={{ fontSize: '12px', fontWeight: '500', color: '#444141', }}>{option.option}</Typography></li>
                                                        </>)
                                                }}
                                            />
                                        </Grid>
                                        <Grid item lg={5.6}>
                                            <FormLabel><FormHeading heading="Brief Description of Product/Service" isRequired={true} /></FormLabel>
                                            <NormalInput
                                                name={"description"}
                                                type={"text"}
                                                style={FORM_INPUTFIELD_STYLES}
                                                isRequired={true}
                                                focused={false}
                                                label={("")}
                                                sizeval="medium"
                                                values={values.description}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                multiline={true}
                                                error={Boolean(touched.description) && errors.description}
                                                helperText={touched.description && errors.description}
                                            />
                                        </Grid>
                                    </Grid>
                                </Box>
                            </Stack>

                            <Stack direction="row" alignItems={"flex-start"} sx={{ border: '0px solid red', marginTop: '32px' }}>
                                <Box sx={{ width: '40%' }}><Typography sx={{ fontSize: '20px', fontWeight: 400, color: 'black', fontFamily: 'var(--family2) !important' }}>
                                    Target Audience</Typography></Box>
                                <Box sx={{ width: '60%', paddingX: 5, border: '0px solid red' }}>

                                    <Grid container justifyContent={"space-evenly"} gap={1.5} sx={{
                                        paddingY: '24px', background: '#FFF', border: '0px solid purple', boxShadow: '0px 0px 24px 0px rgba(0, 0, 0, 0.10)', borderRadius: '10px'
                                    }}>
                                        <Grid item lg={5.6}>
                                            <FormLabel><FormHeading heading="Geographic Preferences (Regions/Countries)" isRequired={true} /></FormLabel>
                                            <AutoSuggestion
                                                sx={{ ...FORM_SELECTFIELD_STYLES, }}
                                                limitTags={1}
                                                CustomPaperComponent={CustomPaperComponent}
                                                multiple={true}
                                                required={true}
                                                disableClearable={true}
                                                value={values?.geoPreferences || []}
                                                className="auto-chips-cover"
                                                label={""}
                                                onChange={(_e, newValue) => {
                                                    handleChange({
                                                        target: { name: "geoPreferences", value: newValue },
                                                    });
                                                }}
                                                renderTags={(value, getTagProps) => {
                                                    if (!Array.isArray(value)) return null;
                                                    return value.map((option, index) => {
                                                        return (
                                                            <Chip
                                                                key={option.option || option}
                                                                label={<Typography sx={{ fontSize: '14px', fontWeight: 500, color: 'white' }}>
                                                                    {option.option?.substring(0, 10) || option}
                                                                </Typography>}
                                                                {...getTagProps({ index })}
                                                                sx={{
                                                                    background: 'black !important',
                                                                    borderRadius: '62px', border: '0px solid #CCCBCB',
                                                                    padding: "3px 8px", height: '32px'
                                                                }}
                                                                deleteIcon={<img src={DeleteIcon} style={{ filter: 'brightness(0) invert(1)', }} alt="delete icon" width={24} height={24} />} // Custom delete icon
                                                            />
                                                        )
                                                    })
                                                }
                                                }
                                                defaultValue={values?.geoPreferences || []}
                                                id={`users-${values?.geoPreferences?.length}`}
                                                size="small"
                                                name="niche"
                                                error={Boolean(touched.geoPreferences) && errors.geoPreferences}
                                                helperText={touched.geoPreferences && errors.geoPreferences}
                                                renderOption={(props, option) => {
                                                    return (
                                                        <>
                                                            <li {...props} style={{ padding: '2px 8px', width: '100%', margin: "0 3px", borderRadius: '0px', border: '0px solid #CCCBCB', display: 'flex', justifyContent: 'flex-start', alignItems: 'center', flexDirection: 'row', gap: 2 }}><Typography sx={{ fontSize: '12px', fontWeight: '500', color: '#444141', }}>{option || ""}</Typography></li>
                                                        </>)
                                                }}
                                                placeholder="Ex. Mumbai, Delhi"
                                                options={citiesInIndia}
                                                isOptionEqualToValue={(option, value) => {
                                                    if (
                                                        value === "" ||
                                                        option === "" ||
                                                        value === option
                                                    )
                                                        return option;
                                                }}
                                                getOptionLabel={(option) =>
                                                    option || "no_option_found"
                                                } />
                                        </Grid>
                                        <Grid item lg={5.6}>
                                            <FormLabel><FormHeading heading="Describe Your Ideal Customer:" isRequired={false} /></FormLabel>
                                            <Editor style={{ height: '100%', width: '100%' }} value={values.additionalInformation} onChange={(e) => {
                                                handleChange({
                                                    target: {
                                                        name: "additionalInformation",
                                                        value: e.target.value
                                                    }
                                                })
                                            }} />
                                        </Grid>
                                    </Grid>
                                </Box>
                            </Stack>

                            <Stack direction="row" alignItems={"flex-start"} sx={{ border: '0px solid red', marginTop: '32px' }}>
                                <Box sx={{ width: '40%' }}><Typography sx={{ fontSize: '20px', fontWeight: 400, color: 'black', fontFamily: 'var(--family2) !important' }}>
                                    General Information</Typography></Box>
                                <Box sx={{ width: '60%', paddingX: 5, border: '0px solid red' }}>
                                    <Grid container justifyContent={"space-evenly"} gap={1.5} sx={{
                                        paddingY: '24px', background: '#FFF', border: '0px solid purple', boxShadow: '0px 0px 24px 0px rgba(0, 0, 0, 0.10)', borderRadius: '10px'
                                    }}>
                                        <Grid item lg={11.5}>
                                            <FormLabel><FormHeading heading="Logo or Visual Assets" isRequired={true} /></FormLabel>
                                            <Box
                                                onDrop={handleDrop}
                                                onDragOver={(e) => e.preventDefault()}
                                                sx={{
                                                    border: '1px dashed #E5E5E5',
                                                    borderRadius: '16px',
                                                    padding: '16px',
                                                    textAlign: 'center',
                                                    cursor: 'pointer',
                                                    background: '#FAFAFA',
                                                    position: 'relative',
                                                    width: '100%', height: '150px'
                                                }}>
                                                <input
                                                    type="file"
                                                    accept="image/*"
                                                    id="fileInput"
                                                    style={{ display: 'block', height: '100%', width: '100%', border: '2px solid red', opacity: 0 }}
                                                    onChange={handleFileChange}
                                                />
                                                <label htmlFor="fileInput" style={{ width: '100%', height: '100%', position: 'absolute', top: 0, left: 0, padding: '16px', cursor: 'pointer' }}>
                                                    {preview ? (
                                                        <Stack
                                                            direction="row" justifyContent="flex-start" gap={1.5} alignItems="center"
                                                            sx={{
                                                                width: '100%',
                                                                height: '100%',
                                                                borderRadius: 2,
                                                                border: '0px solid red'
                                                            }}>
                                                            <Stack direction="row" justifyContent="flex-start" alignItems="center" gap={2} sx={{ height: '100px', width: '90%', background: '#F0F0F0', borderRadius: '10px', padding: '14px' }}>
                                                                <Box sx={{ height: '65px', width: '65px', position: 'relative' }}>
                                                                    <img src={preview} alt="preview" style={{ height: '100%', width: '100%', objectFit: 'cover', borderRadius: '5px' }} />
                                                                    <div style={{ position: 'absolute', top: 0, left: 0, background: 'rgba(0,0,0,0.5)', height: '100%', width: '100%', padding: '17px', borderRadius: '5px' }}>
                                                                        <img src={imageIconWhite} alt="imageIconWhite" style={{ height: '24px', width: '24px' }} />
                                                                    </div>
                                                                </Box>
                                                                <Typography sx={{ color: '#726C6C', fontSize: '14px', fontWeight: 400, minWidth: '200px', textAlign: 'left' }}>{values?.logo?.name?.substring(0, 30) || "Banner Image"}</Typography>
                                                                <img src={check} alt="check" style={{ height: '24px', width: '24px' }} />
                                                            </Stack>
                                                            <Button sx={{ "&:hover": { background: 'transparent' } }} disableRipple onClick={handleDeleteBannerImage}><img src={deleteIconRed} alt="check" style={{ height: '24px', width: '24px' }} /></Button>
                                                        </Stack>
                                                    ) : (
                                                        <>
                                                            <img src={imageIcon} alt="" style={{ height: '32px', width: '32px' }} />
                                                            <Typography variant="body1" sx={{ mt: 0.7, fontSize: '12px', fontWeight: 600 }}>
                                                                <span style={{ color: 'var(--color-blue)', textDecoration: 'underline', }}>
                                                                    Click to upload
                                                                </span>{' '}
                                                                or drag and drop
                                                            </Typography>
                                                            <Typography variant="caption" sx={{ mt: 0.7, display: 'block', color: '#A3A3A3', fontSize: '10px', fontWeight: 400, }}>
                                                                Supported dimensions (pixels) are 180x180 and 300x300. Image formats like JPEG and PNG
                                                            </Typography>
                                                            {bannerImageError && (<Typography sx={{ mt: 0.7, display: 'block', color: 'var(--red)', fontSize: '10px', fontWeight: 400, }}>
                                                                {bannerImageError}
                                                            </Typography>)}
                                                            {errors.logo && touched.logo && (
                                                                <Typography sx={{ mt: 0.7, display: 'block', color: 'var(--red)', fontSize: '10px', fontWeight: 400, }}
                                                                    className="error"

                                                                >
                                                                    {`${errors?.logo}`}
                                                                </Typography>
                                                            )}
                                                        </>
                                                    )}
                                                </label>
                                            </Box>
                                        </Grid>
                                        <Grid item lg={5.6}>
                                            <FormLabel><FormHeading heading="Primary Color" isRequired={true} /></FormLabel>
                                            <NormalInput
                                                isRequired={true}
                                                name={"primaryColor"}
                                                type={"text"}
                                                focused={false}
                                                label={("")}
                                                sizeval="medium"
                                                style={FORM_INPUTFIELD_STYLES}
                                                values={values.primaryColor}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={Boolean(touched.primaryColor) && errors.primaryColor}
                                                helperText={touched.primaryColor && errors.primaryColor}
                                            />
                                        </Grid>
                                        <Grid item lg={5.6}>
                                            <FormLabel><FormHeading heading="Secondary Color" isRequired={true} /></FormLabel>

                                            <NormalInput
                                                name={"secondaryColor"}
                                                type={"text"}
                                                focused={false}
                                                label={("")}
                                                sizeval="medium"
                                                values={values.secondaryColor}
                                                style={FORM_INPUTFIELD_STYLES}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={Boolean(touched.secondaryColor) && errors.secondaryColor}
                                                helperText={touched.secondaryColor && errors.secondaryColor}
                                            />
                                        </Grid>
                                        <Grid item lg={5.6}>
                                            <FormLabel><FormHeading heading="Font Preferences" isRequired={true} /></FormLabel>
                                            <Select
                                                sx={FORM_SELECTFIELD_STYLES} MenuProps={{
                                                    PaperProps: {
                                                        sx: {
                                                            borderRadius: "8px",
                                                            mt: 1,
                                                        },
                                                    },
                                                }}
                                                required={false}
                                                name={`font`}
                                                label={("")}
                                                values={values.font}
                                                handleChange={handleChange}
                                                handleBlur={handleBlur}
                                            >
                                                {fontReference?.map(
                                                    (v) => {
                                                        return (
                                                            <MenuItem value={v} key={v}>
                                                                {v}
                                                            </MenuItem>
                                                        );
                                                    }
                                                )}

                                            </Select>
                                            {errors.font && touched.font && (
                                                <p
                                                    className="error"

                                                >
                                                    {`${errors?.font}`}
                                                </p>
                                            )}
                                        </Grid>
                                        <Grid lg={5.6}></Grid>

                                    </Grid>
                                </Box>
                            </Stack>

                            <Stack direction="row" alignItems={"flex-start"} sx={{ border: '0px solid red', marginTop: '32px' }}>
                                <Box sx={{ width: '40%' }}><Typography sx={{ fontSize: '20px', fontWeight: 400, color: 'black', fontFamily: 'var(--family2) !important' }}>
                                    Social Media Presence</Typography>
                                    <Typography sx={{ fontSize: '12px', fontWeight: 400, color: '#726C6C', fontFamily: 'var(--family1)' }}>
                                        Add Platform URL’s Existing Social Media Profile (Please provide links):</Typography>
                                </Box>
                                <Box sx={{ width: '60%', paddingX: 5, border: '0px solid red' }}>

                                    <Grid container justifyContent={"space-evenly"} gap={2} sx={{
                                        paddingY: '24px', background: '#FFF', border: '0px solid purple', boxShadow: '0px 0px 24px 0px rgba(0, 0, 0, 0.10)', borderRadius: '10px'
                                    }}>
                                        <Grid item lg={isScreenZoomed ? 2 :1.6} sx={{ border: '0px solid red' }}>
                                            <Stack direction="row" alignItems="center" sx={{
                                                borderRadius: '8px',
                                                padding: '8px 14px',
                                                position: 'relative',
                                                zIndex: 0,width:'100%',
                                                backgroundColor: '#fff',
                                                border: '1px solid #CCCBCB',
                                                "&::before": {
                                                    content: '""',
                                                    position: 'absolute',
                                                    top: -2,
                                                    left: -2,
                                                    right: -2,
                                                    bottom: -2,
                                                    borderRadius: 'inherit',
                                                    padding: '2px',
                                                    background: values?.instagramInfo?.length > 0
                                                        ? 'linear-gradient(90deg, rgba(255, 204, 112, 1), rgba(200, 80, 192, 1), rgba(65, 88, 208, 1))'
                                                        : 'transparent',
                                                    WebkitMask:
                                                        'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
                                                    WebkitMaskComposite: 'xor',
                                                    maskComposite: 'exclude',
                                                    zIndex: -1,
                                                    transition: 'background 0.3s ease',
                                                },
                                                "&:hover": {
                                                    border: '1px solid transparent',
                                                },
                                                "&:hover::before": {
                                                    background: 'linear-gradient(90deg, rgba(255, 204, 112, 1), rgba(200, 80, 192, 1), rgba(65, 88, 208, 1))',
                                                },
                                            }}>
                                                <Button disableRipple sx={{ p: 0, m: 0, background: 'transparent', "&:hover": { background: 'transparent' } }} onClick={() => {
                                                    if (values?.instagramInfo?.length > 0) {
                                                        handleChange({
                                                            target: {
                                                                name: "instagramInfo",
                                                                value: []
                                                            }
                                                        });
                                                    } else {
                                                        handleChange({
                                                            target: {
                                                                name: "instagramInfo",
                                                                value: [{ userName: "", url: "" }]
                                                            }
                                                        })
                                                    }
                                                }}>


                                                    <img src={PLATFORMS_IMGS_LIST["Instagram"]} alt={"Instagram"} style={{ height: '24px', width: '24px' }} />&nbsp;&nbsp;<Typography sx={{
                                                        fontSize: '14px',
                                                        fontWeight: 400,
                                                        cursor: 'pointer',
                                                        color: 'black',
                                                        background: values?.instagramInfo?.length > 0
                                                            ? 'linear-gradient(90deg, rgba(255,204,112,1), rgba(200,80,192,1), rgba(65,88,208,1))'
                                                            : 'none',
                                                        WebkitBackgroundClip: values?.instagramInfo?.length > 0 ? 'text' : 'unset',
                                                        WebkitTextFillColor: values?.instagramInfo?.length > 0 ? 'transparent' : 'inherit',
                                                        transition: 'all 0.3s ease',

                                                        "&:hover": {
                                                            background:
                                                                'linear-gradient(90deg, rgba(255,204,112,1), rgba(200,80,192,1), rgba(65,88,208,1))',
                                                            WebkitBackgroundClip: 'text',
                                                            WebkitTextFillColor: 'transparent',
                                                        },
                                                    }}>Instagram</Typography>
                                                </Button>
                                            </Stack>
                                        </Grid>
                                        <Grid item lg={isScreenZoomed ? 9 : 9.6} sx={{ border: '0px solid blue' }}>
                                            {/* empty div needed */}
                                        </Grid>

                                        {values?.instagramInfo?.length > 0 &&
                                            <FieldArray
                                                name={`instagramInfo`}
                                                render={(array) => (
                                                    <>{values?.instagramInfo?.map(
                                                        (post, index) => (
                                                            <>
                                                                <Grid item xs={12} lg={3.2} md={3} sm={3}>
                                                                    <FormHeading heading={`Username ${index + 1}`} isRequired={true} />
                                                                    <NormalInput
                                                                        name={`instagramInfo.[${index}].userName`}
                                                                        type={"text"}
                                                                        isRequired={true}
                                                                        focused={false}
                                                                        label={("")}
                                                                        sizeval="medium"
                                                                        values={
                                                                            values.instagramInfo[index].userName
                                                                        }
                                                                        onChange={handleChange}
                                                                        onBlur={handleBlur}
                                                                        style={FORM_INPUTFIELD_STYLES}

                                                                    />

                                                                    <Field
                                                                        name={`instagramInfo.[${index}].userName`}
                                                                        render={({ form }) => {
                                                                            const error = getIn(
                                                                                form.errors,
                                                                                `instagramInfo.[${index}].userName`,
                                                                            );
                                                                            const touch = getIn(
                                                                                form.touched,
                                                                                `instagramInfo.[${index}].userName`,
                                                                            );
                                                                            return touch && error ? (
                                                                                <p className="error">
                                                                                    {error}
                                                                                </p>
                                                                            ) : null;
                                                                        }}
                                                                    />

                                                                </Grid>

                                                                <Grid item xs={12} lg={8} md={7.5} sm={7.5}>
                                                                    <FormHeading heading={`URL ${index + 1}`} isRequired={true} />
                                                                    <Stack direction="row" alignItems="center" justifyItems="flex-start" gap={1}>

                                                                        <Box sx={{ width: '100%' }}>

                                                                            <NormalInput
                                                                                name={`instagramInfo.[${index}].url`}
                                                                                type={"text"}
                                                                                isRequired={true}
                                                                                focused={false}
                                                                                label={("")}
                                                                                sizeval="medium"
                                                                                values={
                                                                                    values.instagramInfo[index].url
                                                                                }
                                                                                onChange={handleChange}
                                                                                onBlur={handleBlur}
                                                                                style={FORM_INPUTFIELD_STYLES}

                                                                            />
                                                                            <Field
                                                                                name={`instagramInfo.[${index}].url`}
                                                                                render={({ form }) => {
                                                                                    const error = getIn(
                                                                                        form.errors,
                                                                                        `instagramInfo.[${index}].url`,
                                                                                    );
                                                                                    const touch = getIn(
                                                                                        form.touched,
                                                                                        `instagramInfo.[${index}].url`,
                                                                                    );
                                                                                    return touch && error ? (
                                                                                        <p className="error">
                                                                                            {error}
                                                                                        </p>
                                                                                    ) : null;
                                                                                }}
                                                                            />
                                                                        </Box>
                                                                        {index === 0 ? <img src={addIcon} onClick={() => {
                                                                            array.push({
                                                                                userName: "",
                                                                                url: "",
                                                                            });
                                                                        }} alt="plus" style={{ width: '28px', height: '28px', cursor: 'pointer' }} /> : <img src={removeIcon}
                                                                            onClick={(e) => {
                                                                                e.preventDefault();
                                                                                array.remove(index);
                                                                            }} alt="minus" style={{ width: '28px', height: '28px', cursor: 'pointer' }} />}
                                                                    </Stack>
                                                                </Grid>
                                                            </>
                                                        ))}
                                                    </>
                                                )}
                                            />}

                                        <Grid item lg={isScreenZoomed ? 2 :1.6} sx={{ border: '0px solid red' }}>
                                            <Stack direction="row" alignItems="center" sx={{
                                                borderRadius: '8px',
                                                padding: '8px 14px',
                                                position: 'relative',
                                                zIndex: 0,
                                                backgroundColor: '#fff',
                                                border: '1px solid #CCCBCB',
                                                "&::before": {
                                                    content: '""',
                                                    position: 'absolute',
                                                    top: -2,
                                                    left: -2,
                                                    right: -2,
                                                    bottom: -2,
                                                    borderRadius: 'inherit',
                                                    padding: '2px',
                                                    background: values?.youtubeInfo?.length > 0
                                                        ? 'linear-gradient(90deg, rgba(255, 204, 112, 1), rgba(200, 80, 192, 1), rgba(65, 88, 208, 1))'
                                                        : 'transparent',
                                                    WebkitMask:
                                                        'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
                                                    WebkitMaskComposite: 'xor',
                                                    maskComposite: 'exclude',
                                                    zIndex: -1,
                                                    transition: 'background 0.3s ease',
                                                },
                                                "&:hover": {
                                                    border: '1px solid transparent',
                                                },
                                                "&:hover::before": {
                                                    background: 'linear-gradient(90deg, rgba(255, 204, 112, 1), rgba(200, 80, 192, 1), rgba(65, 88, 208, 1))',
                                                },
                                            }}>
                                                <Button disableRipple sx={{ p: 0, m: 0, background: 'transparent', "&:hover": { background: 'transparent' } }} onClick={() => {
                                                    if (values?.youtubeInfo?.length > 0) {
                                                        handleChange({
                                                            target: {
                                                                name: "youtubeInfo",
                                                                value: []
                                                            }
                                                        });
                                                    } else {
                                                        handleChange({
                                                            target: {
                                                                name: "youtubeInfo",
                                                                value: [{ userName: "", url: "" }]
                                                            }
                                                        })
                                                    }
                                                }}>
                                                    <img src={PLATFORMS_IMGS_LIST["Youtube"]} alt={"Youtube"} style={{ height: '24px', width: '24px' }} />&nbsp;&nbsp;<Typography sx={{
                                                        fontSize: '14px',
                                                        fontWeight: 400,
                                                        cursor: 'pointer',
                                                        color: 'black',
                                                        background: values?.youtubeInfo?.length > 0
                                                            ? 'linear-gradient(90deg, rgba(255,204,112,1), rgba(200,80,192,1), rgba(65,88,208,1))'
                                                            : 'none',
                                                        WebkitBackgroundClip: values?.youtubeInfo?.length > 0 ? 'text' : 'unset',
                                                        WebkitTextFillColor: values?.youtubeInfo?.length > 0 ? 'transparent' : 'inherit',
                                                        transition: 'all 0.3s ease',

                                                        "&:hover": {
                                                            background:
                                                                'linear-gradient(90deg, rgba(255,204,112,1), rgba(200,80,192,1), rgba(65,88,208,1))',
                                                            WebkitBackgroundClip: 'text',
                                                            WebkitTextFillColor: 'transparent',
                                                        },
                                                    }}>Youtube</Typography>
                                                </Button>
                                            </Stack>
                                        </Grid>
                                        <Grid item lg={isScreenZoomed ? 9 : 9.6} sx={{ border: '0px solid blue' }}>
                                            {/* empty div needed */}
                                        </Grid>
                                        {values?.youtubeInfo?.length > 0 &&
                                            <FieldArray
                                                name={`youtubeInfo`}
                                                render={(array) => (
                                                    <>{values?.youtubeInfo?.map(
                                                        (post, index) => (
                                                            <>
                                                                <Grid item xs={12} lg={3.2} md={3} sm={3}>
                                                                    <FormHeading heading={`Username ${index + 1}`} isRequired={true} />
                                                                    <NormalInput
                                                                        name={`youtubeInfo.[${index}].userName`}
                                                                        type={"text"}
                                                                        isRequired={true}
                                                                        focused={false}
                                                                        label={("")}
                                                                        sizeval="medium"
                                                                        values={
                                                                            values.youtubeInfo[index].userName
                                                                        }
                                                                        onChange={handleChange}
                                                                        onBlur={handleBlur}
                                                                        style={FORM_INPUTFIELD_STYLES} />

                                                                    <Field
                                                                        name={`youtubeInfo.[${index}].userName`}
                                                                        render={({ form }) => {
                                                                            const error = getIn(
                                                                                form.errors,
                                                                                `youtubeInfo.[${index}].userName`,
                                                                            );
                                                                            const touch = getIn(
                                                                                form.touched,
                                                                                `youtubeInfo.[${index}].userName`,
                                                                            );
                                                                            return touch && error ? (
                                                                                <p className="error">
                                                                                    {error}
                                                                                </p>
                                                                            ) : null;
                                                                        }}
                                                                    />
                                                                </Grid>

                                                                <Grid item xs={12} lg={8} md={7.5} sm={7.5}>
                                                                    <FormHeading heading={`URL ${index + 1}`} isRequired={true} />
                                                                    <Stack direction="row" alignItems="center" justifyItems="flex-start" gap={1}>

                                                                        <Box sx={{ width: '100%' }}>
                                                                            <NormalInput
                                                                                name={`youtubeInfo.[${index}].url`}
                                                                                type={"text"}
                                                                                isRequired={true}
                                                                                focused={false}
                                                                                label={("")}
                                                                                sizeval="medium"
                                                                                values={
                                                                                    values.youtubeInfo[index].url
                                                                                }
                                                                                onChange={handleChange}
                                                                                onBlur={handleBlur}
                                                                                style={FORM_INPUTFIELD_STYLES} />
                                                                            <Field
                                                                                name={`youtubeInfo.[${index}].url`}
                                                                                render={({ form }) => {
                                                                                    const error = getIn(
                                                                                        form.errors,
                                                                                        `youtubeInfo.[${index}].url`,
                                                                                    );
                                                                                    const touch = getIn(
                                                                                        form.touched,
                                                                                        `youtubeInfo.[${index}].url`,
                                                                                    );
                                                                                    return touch && error ? (
                                                                                        <p className="error">
                                                                                            {error}
                                                                                        </p>
                                                                                    ) : null;
                                                                                }}
                                                                            />
                                                                        </Box>
                                                                        {index === 0 ? <img src={addIcon} onClick={() => {
                                                                            array.push({
                                                                                userName: "",
                                                                                url: "",
                                                                            });
                                                                        }} alt="plus" style={{ width: '28px', height: '28px', cursor: 'pointer' }} /> : <img src={removeIcon}
                                                                            onClick={(e) => {
                                                                                e.preventDefault();
                                                                                array.remove(index);
                                                                            }} alt="minus" style={{ width: '28px', height: '28px', cursor: 'pointer' }} />}
                                                                    </Stack>
                                                                </Grid>

                                                            </>
                                                        ))}
                                                    </>
                                                )}
                                            />}

                                    </Grid>
                                </Box>
                            </Stack>

                            <Stack direction="row" alignItems={"flex-start"} sx={{ border: '0px solid red', marginTop: '32px' }}>
                                <Box sx={{ width: '40%' }}><Typography sx={{ fontSize: '20px', fontWeight: 400, color: 'black', fontFamily: 'var(--family2) !important' }}>
                                    Company Values and Messages</Typography></Box>
                                <Box sx={{ width: '60%', paddingX: 5, border: '0px solid red' }}>

                                    <Grid container justifyContent={"space-evenly"} gap={1.5} sx={{
                                        paddingY: '24px', background: '#FFF', border: '0px solid purple', boxShadow: '0px 0px 24px 0px rgba(0, 0, 0, 0.10)', borderRadius: '10px'
                                    }}>
                                        <Grid item lg={5.6}>
                                            <FormLabel><FormHeading heading="Key Messages or Company Talking Points" isRequired={true} /></FormLabel>

                                            <Editor value={values.messagesKey} onChange={(e) => {
                                                handleChange({
                                                    target: {
                                                        name: "messagesKey",
                                                        value: e.target.value
                                                    }
                                                })
                                            }} />
                                        </Grid>
                                        <Grid item lg={5.6}>
                                            <FormLabel><FormHeading heading="Tone of Voice Communication Style" isRequired={true} /></FormLabel>
                                            <Editor value={values.toneOfVoice} onChange={(e) => {
                                                handleChange({
                                                    target: {
                                                        name: "toneOfVoice",
                                                        value: e.target.value
                                                    }
                                                })
                                            }} />
                                        </Grid>
                                    </Grid>
                                </Box>
                            </Stack>

                            <Stack direction="row" alignItems={"flex-start"} sx={{ border: '0px solid red', marginTop: '32px' }}>
                                <Box sx={{ width: '40%' }}><Typography sx={{ fontSize: '20px', fontWeight: 400, color: 'black', fontFamily: 'var(--family2) !important' }}>
                                    Additional Information</Typography></Box>
                                <Box sx={{ width: '60%', paddingX: 5, border: '0px solid red' }}>

                                    <Grid container justifyContent={"space-evenly"} gap={1.5} sx={{
                                        paddingY: '24px', background: '#FFF', border: '0px solid purple', boxShadow: '0px 0px 24px 0px rgba(0, 0, 0, 0.10)', borderRadius: '10px'
                                    }}>
                                        <Grid item lg={11.6}>
                                            <FormLabel><FormHeading heading="Describe Your Ideal Customer" isRequired={true} /></FormLabel>

                                            <Editor value={values.idealDescription} onChange={(e) => {
                                                handleChange({
                                                    target: {
                                                        name: "idealDescription",
                                                        value: e.target.value
                                                    }
                                                })
                                            }} />
                                        </Grid>
                                    </Grid>
                                </Box>
                            </Stack>


                            {values.comingFrom === "profile" && <Stack direction="row" alignItems={"flex-start"} sx={{ border: '0px solid red', marginTop: '32px' }}>
                                <Box sx={{ width: '40%' }}><Typography sx={{ fontSize: '20px', fontWeight: 400, color: 'black', fontFamily: 'var(--family2) !important' }}>
                                    Company Question and Answers</Typography></Box>
                                <Box sx={{ width: '60%', paddingX: 5, border: '0px solid red' }}>

                                    <Grid container justifyContent={"space-evenly"} gap={1.5} sx={{
                                        paddingY: '24px', background: '#FFF', border: '0px solid purple', boxShadow: '0px 0px 24px 0px rgba(0, 0, 0, 0.10)', borderRadius: '10px'
                                    }}>

                                        {COMPANY_QUE_FLOW.map((v) => {
                                            return <Grid item key={v.name} xs={6} lg={5.6} md={6} sm={6}>
                                                <FormLabel><FormHeading heading={v.question} isRequired={true} /></FormLabel>
                                                <FormControl>
                                                    <RadioGroup
                                                        aria-labelledby="demo-controlled-radio-buttons-group"
                                                        name={v.name}
                                                        onChange={handleChange}
                                                        value={values[v.name]}
                                                    >
                                                        {v.answer.map((v) => <FormControlLabel key={v} value={v} control={<Radio />} label={v} />)}
                                                    </RadioGroup>
                                                </FormControl>
                                            </Grid>
                                        })}
                                        <Grid item lg={5.6}>
                                            {/* need Empty Div */}
                                        </Grid>
                                    </Grid>
                                </Box>
                            </Stack>}
                            <Grid container>
                                <Grid item xs={12} lg={12} md={12} sm={12} sx={{ paddingX: 5, paddingTop: '32px' }} container justifyContent="flex-end">
                                    <Stack direction={"row"} spacing={1}>

                                        <Button onClick={(e) => {
                                            e.preventDefault();
                                            if (state?.comingFrom) {
                                                navigate(-1)
                                            } else {
                                                navigate("/companies")
                                            }
                                        }} sx={{ height: '44px', width: '100px', padding: '14px 16px', borderRadius: '8px', border: '1px solid #726C6C', background: 'white', color: '#726C6C' }}><Typography sx={{ fontSize: '14px', fontWeight: 600 }}>Back</Typography></Button>


                                        <Button
                                            type="submit"
                                            sx={{ width: '130px', height: '44px', borderRadius: '8px', color: 'white', background: 'linear-gradient(125deg,rgba(255, 204, 112, 1) 0%, rgba(200, 80, 192, 1) 50%, rgba(65, 88, 208, 1) 100%)' }}
                                        >
                                            <Typography sx={{ fontSize: '14px', fontWeight: 600, color: 'white' }}>{state?.userId ? "Update" : "Submit"}</Typography>
                                        </Button>
                                    </Stack>
                                </Grid>

                            </Grid>
                        </Box>
                    </Form>)
            }}
        </Formik>
        </>
    );

}
export default AddEditCompany;